import type { ValueListMap } from '@config/interfaces';
import type { ListRow, ValueStatus } from './interfaces';

const ACRONYMS: Record<string, string> = { ERC: 'ERC', ID: 'ID', BDMS: 'BDMs' };

/** ACTION_ENTITY_TYPE -> Action entity type, until the platform carries a name of its own. */
export const toName = (id: string): string =>
  id
    .replace(/[_.]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((word, index) => ACRONYMS[word] ?? (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word.toLowerCase()))
    .join(' ');

/** Every value is selectable today, so the platform's other states have nothing to report yet. */
const DEFAULT_STATUS: ValueStatus = 'active';

export const toRows = (lists: ValueListMap | null, statusLabels?: Record<ValueStatus, string>): ListRow[] =>
  Object.entries(lists ?? {})
    .map(([id, values]) => {
      const entries = Object.entries(values ?? {});

      return {
        id,
        name: toName(id),
        count: entries.length,
        // The source returns the values in the order it wants them shown, and only the selectable ones.
        values: entries.map(([code, label], index) => ({
          code,
          label,
          order: index + 1,
          status: { key: DEFAULT_STATUS, value: statusLabels?.[DEFAULT_STATUS] ?? DEFAULT_STATUS },
        })),
      };
    })
    .sort((a, b) => a.id.localeCompare(b.id));
